var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkCoursesArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.581421,
    width: 15.4186,
    height: 14.9046,
    rx: 7.45232,
    fill: "#0069CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.481 7.81557C11.6817 7.61486 11.6817 7.28944 11.481 7.08873L8.21024 3.81795C8.00953 3.61724 7.68411 3.61724 7.4834 3.81795C7.28269 4.01866 7.28269 4.34408 7.4834 4.54479L10.3908 7.45215L7.4834 10.3595C7.28269 10.5602 7.28269 10.8856 7.4834 11.0863C7.68411 11.2871 8.00952 11.2871 8.21024 11.0863L11.481 7.81557ZM5.46411 7.9661L11.1176 7.9661L11.1176 6.9382L5.46411 6.9382L5.46411 7.9661Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCoursesArrowIcon);
export default __webpack_public_path__ + "static/media/Dark-Courses-Arrow-Icon.e5436155d1a49787a1077ba41f07a824.svg";
export { ForwardRef as ReactComponent };